import React from 'react'
import { graphql } from 'gatsby'
import parse from "html-react-parser"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon";
import StructuredText from "../custom-structured-text-renderer"

const ThreeColumnContent = ({items}) => {
  return (
    <section className="three-column-content">
        <div className='three-column-content__inner'>
          <div className="three-column-content__wrapper">
            <div className="line line--horizon center-left"></div>

            <div className="three-column-content__items">
              <div className="line line--vertical center-top"></div>
              <div className="line line--vertical center-bottom"></div>

              {
                items?.length > 0 && items?.map((item, index) => (
                  <div key={index} className="three-column-content__item">
                    {item.image && <Asset asset={item.image} />}
                    {item.title && <h3>{parse(item.title)}</h3>}
                    {item.richContent && <StructuredText data={item.richContent} />}
                  </div>
                ))
              }
            </div>
          </div>
        </div>
    </section>
  )
}

export default ThreeColumnContent

export const query = graphql`
fragment ThreeColumnContentProps on DatoCmsThreeColumnContent {
  ... on DatoCmsThreeColumnContent {
    id
    items {
      image {
        ...InternalAssetProps
      }
      title
      richContent {
        value
      }
    }
  }
}
`;